import PromotionBanner from "./PromotionBanner";
export default PromotionBanner;
